import { render, staticRenderFns } from "./StyleHeader.vue?vue&type=template&id=210ae332&"
import script from "./StyleHeader.vue?vue&type=script&lang=js&"
export * from "./StyleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports